const Services = (props) => {
    return(
        <section id="services-background">
            <div className="services-section-main">
                <div className="services-img"> <img src="./image/CryptidImage.png" alt={""} /> </div>
                <div className="services-text">
                    <h3>THE CRYPTIDS</h3>
                    <p>Human civilizations rose and fell throughout the millennia. The Cryptids saw it all.<br />
                        They existed at the fringes of the world, knowing they must remain separate from the humans
                        they would help. The Gyld mountain is their refuge, far away from humankind's domain yet close
                        enough to see and understand our travails. They care for us, despite our bloody and destructive
                        ways. They want us to rise from the depths of depravity and shine in a just and sustainable
                        society.<br />
                        The Cryptids, mythical apes known as Sasquatch, Bigfoot and Yeti, thought this dream of theirs
                        would never come to pass.The Cryptids have decided to reveal themselves to the world. They
                        have formed the Council of Gyld.</p>
                    {/*<a href="">Read more</a> */}
                </div>
            </div>
        </section>
    )
}

export default Services;